import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "react-router-dom";

interface AuthorCardProps {
  name: string;
  role: string;
  image: string;
  date: string;
  readTime: string;
}

export function AuthorCard({ name, role, image, date, readTime }: AuthorCardProps) {
  return (
    <div className="flex items-center gap-4 mt-6">
      <Link to="/about" className="flex-shrink-0">
        <Avatar className="h-12 w-12 border-2 border-primary/20 hover:border-primary/50 transition-colors">
          <AvatarImage src={image} alt={`${name} - ${role}`} loading="lazy" />
          <AvatarFallback className="bg-primary/10 text-primary font-semibold" aria-label={name}>
            {name.split(' ').map(n => n[0]).join('')}
          </AvatarFallback>
        </Avatar>
      </Link>
      <div className="flex flex-col">
        <Link to="/about" className="font-semibold text-foreground hover:text-primary transition-colors">
          {name}
        </Link>
        <span className="text-sm text-muted-foreground">{role}</span>
      </div>
      <div className="hidden sm:flex items-center gap-3 ml-auto text-sm text-muted-foreground">
        <span>{date}</span>
        <span>•</span>
        <span>{readTime}</span>
      </div>
    </div>
  );
}

export const authorInfo = {
  name: "Ranvir Gill",
  role: "Founder & CEO, CheckFirst",
  image: "/ranvir-gill.jpg"
};
